import { Injectable } from "@angular/core";
import { ReplaySubject, switchMap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { env } from "@environments/environment";

@Injectable({ providedIn: "root" })
export class AccountService {

  constructor(private readonly http: HttpClient) {
    this.http.get(env.logisticsServiceBackend + "/logistics/v1/user/current/context")
      .pipe(
        switchMap((data: any) => {
          this.userIdentity = data;
          this.authenticationState.next(data);
          return this.http.get(env.logisticsServiceBackend + "/logistics/v1/organizations/" + data.organizationInfo.organizationId);
        }),
      )
      .subscribe((data: any) => {
        this.organizationIdentity = data;
      });
  }

  private userIdentity: any | null = null;
  private organizationIdentity: any | null = null;
  private authenticationState: ReplaySubject<any> = new ReplaySubject<any | null>(1);

  authenticate(identity: any | null): void {
    this.userIdentity = identity;
    this.authenticationState.next(this.userIdentity);
  }

  isDOZ(): boolean {
    if (!this.userIdentity || !this.userIdentity.organizationInfo) {
      return false;
    }
    return this.userIdentity.organizationInfo.organizationCode === "00000002";

  }

  isMZU(): boolean {
    if (!this.userIdentity || !this.userIdentity.organizationInfo) {
      return false;
    }
    return this.userIdentity.organizationInfo.organizationCode === "00000001";

  }

  fullName(): string {
    if ((!this.userIdentity)) {
      return "<noname>";
    }
    return this.userIdentity.fullName;

  }

  organizationShortName(): string {
    if ((!this.userIdentity || !this.userIdentity.organizationInfo)) {
      return "<noname>";
    }
    return this.userIdentity.organizationInfo.organizationShortNameUa;

  }

  regionId(): number {
    if ((!this.organizationIdentity) || !this.organizationIdentity.region) {
      return -1;
    }
    return this.organizationIdentity.region.id;

  }

  nameAbr(): string {
    if ((!this.userIdentity || !this.userIdentity.username || !this.userIdentity.lastName)) {
      return "UU";
    }
    return "" + Array.from(this.userIdentity.username)[0] + Array.from(this.userIdentity.lastName)[0];

  }
}
